"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Product = void 0;
var _analyticsData = require("@ori/analytics-data");
var _culture = require("@ori/culture");
var _productBox = require("@ori/product-box");
var _react = require("react");
var _contexts = require("../../../../contexts");
var _hooks = require("../../../../hooks");
var _utils = require("../../../../utils");
var _components = require("./components");
var _styles = require("./styles");
var _useProductLimits = require("./useProductLimits");
var _utils2 = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component to render product.
 */
const Product = ({
  isSingleOffer = false,
  offerItem,
  position
}) => {
  const {
    culture,
    financialSet
  } = (0, _culture.useCulture)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    isCampaignOffer,
    loading,
    updatingProducts,
    onChangeQuantity
  } = (0, _contexts.useOfferDetail)();
  const {
    isHeartFormat
  } = (0, _contexts.useCheckoutOffers)();
  const {
    amount,
    points: rawPoints,
    price: rawPrice,
    originalPrice: rawOriginalPrice,
    productBox
  } = offerItem;
  const {
    maxQuantityToBuy,
    quantity,
    remainingItemQuantity,
    remainingQuantity,
    remainingQuantityPerAmount,
    remainingQuantityPerPoints
  } = (0, _useProductLimits.useProductLimits)({
    offerItem
  });
  const [quantityPickerValue, setQuantityPickerValue] = (0, _react.useState)(quantity);
  const [visibilityTriggerClicked, setVisibilityTriggerClicked] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (!loading) {
      setQuantityPickerValue(quantity);
    }
  }, [loading, quantity]);
  const formatPrice = (0, _react.useCallback)(price => (0, _culture.formatCurrency)(price, culture, financialSet), [culture, financialSet]);
  const price = (0, _react.useMemo)(() => (0, _utils2.getPrice)({
    formatPrice,
    productBoxPrice: productBox.price,
    rawOriginalPrice,
    rawPrice
  }), [formatPrice, productBox.price, rawOriginalPrice, rawPrice]);
  const onChange = (0, _react.useCallback)(value => {
    if (value !== quantity) {
      onChangeQuantity({
        itemCode: productBox.code,
        quantity: value,
        localName: productBox.name,
        formattedPrice: price.currentFormatted,
        position
      });
    }
  }, [onChangeQuantity, position, price.currentFormatted, productBox.code, productBox.name, quantity]);
  const onQuantityPickerChange = (0, _react.useCallback)((value, id, source) => {
    setQuantityPickerValue((0, _utils2.parseQuantityPickerValue)({
      maxQuantityToBuy,
      value
    }));
    if (source === 'decrease' || source === 'increase' || source === 'input-blur') {
      onChange((0, _utils2.parseQuantityPickerValueToNumber)({
        maxQuantityToBuy,
        value
      }));
    }
  }, [maxQuantityToBuy, onChange]);
  const onQuickBuyButtonClick = (0, _react.useCallback)(({
    newValue
  }) => {
    const parsedValue = (0, _utils2.parseQuantityPickerValueToNumber)({
      maxQuantityToBuy,
      value: newValue
    });
    setQuantityPickerValue(parsedValue);
    onChange(parsedValue);
    setVisibilityTriggerClicked(true);
  }, [maxQuantityToBuy, onChange]);
  const onQuantityPickerKeyDown = (0, _react.useCallback)(event => {
    if (event.key === 'ArrowUp') {
      setQuantityPickerValue(prevValue => (0, _utils2.parseValue)({
        value: (0, _utils2.parseQuantityPickerValueToNumber)({
          maxQuantityToBuy,
          value: prevValue
        }) + 1,
        maxQuantityToBuy
      }));
    } else if (event.key === 'ArrowDown') {
      setQuantityPickerValue(prevValue => (0, _utils2.parseValue)({
        value: (0, _utils2.parseQuantityPickerValueToNumber)({
          maxQuantityToBuy,
          value: prevValue
        }) - 1,
        maxQuantityToBuy
      }));
    }
  }, [maxQuantityToBuy]);
  const buttons = (0, _react.useMemo)(() => (0, _utils2.getButtons)({
    maxQuantityToBuy,
    productBoxButtons: productBox.buttons,
    quantity
  }), [maxQuantityToBuy, productBox.buttons, quantity]);
  const points = (0, _react.useMemo)(() => (0, _utils2.getPoints)({
    isCampaignOffer,
    isHeartFormat,
    rawPoints
  }), [isCampaignOffer, isHeartFormat, rawPoints]);
  const quantityPicker = (0, _react.useMemo)(() => ({
    maxValue: maxQuantityToBuy,
    value: quantityPickerValue,
    visible: quantity > 0,
    tooltipMaxText: (0, _utils.getTooltipMaxText)({
      formatMessage,
      isCampaignOffer,
      isHeartFormat
    }),
    tooltipMaxDisabled: updatingProducts,
    visibilityTriggerClicked,
    onChange: onQuantityPickerChange,
    onKeyDown: onQuantityPickerKeyDown
  }), [formatMessage, isCampaignOffer, isHeartFormat, maxQuantityToBuy, onQuantityPickerChange, onQuantityPickerKeyDown, quantity, quantityPickerValue, updatingProducts, visibilityTriggerClicked]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.DebugProduct, {
      amount: amount,
      maxQuantityToBuy: maxQuantityToBuy,
      remainingItemQuantity: remainingItemQuantity,
      remainingQuantity: remainingQuantity,
      remainingQuantityPerAmount: remainingQuantityPerAmount,
      remainingQuantityPerPoints: remainingQuantityPerPoints
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ProductBox, {
      hideRating: true,
      isSingleOffer: isSingleOffer,
      ...productBox,
      points: points,
      price: price,
      buttons: buttons,
      analyticsData: {
        placement: _analyticsData.Placement.Offers,
        position
      },
      quantityPicker: quantityPicker,
      mode: _productBox.ProductBoxMode.Product,
      withTranslationsProvider: false,
      onQuickBuyButtonClick: onQuickBuyButtonClick
    }, productBox.code)]
  });
};
exports.Product = Product;